import { render } from "./MonTargetPerformance.vue?vue&type=template&id=70fe406a&scoped=true"
import script from "./MonTargetPerformance.vue?vue&type=script&lang=js"
export * from "./MonTargetPerformance.vue?vue&type=script&lang=js"

import "./MonTargetPerformance.vue?vue&type=style&index=0&id=70fe406a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fe406a"],['__file',"src/containers/popup/MonTargetPerformance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70fe406a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70fe406a', __exports__)) {
    api.reload('70fe406a', __exports__)
  }
  
  module.hot.accept("./MonTargetPerformance.vue?vue&type=template&id=70fe406a&scoped=true", () => {
    api.rerender('70fe406a', render)
  })

}


export default __exports__